// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openModal, logoutUser, setForm } from '../actions';
import UserMenuForm from '../ui/components/UserMenu';

type Props = {
    auth: {
        isAuthenticated: boolean,
    },
    hideUserMenu: boolean,
    branding: Object,
    openModal: Function,
    logoutUser: Function,
    setForm: Function,
};

export class UserMenu extends Component<Props> {
    render() {
        const { auth, hideUserMenu, branding } = this.props;

        if (auth.isAuthenticated && !hideUserMenu) {
            return (
                <UserMenuForm
                    setForm={this.props.setForm}
                    openModal={this.props.openModal}
                    logout={this.props.logoutUser}
                    auth={auth}
                    branding={branding}
                />
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: Object) => {
    return {
        auth: state.auth,
        hideUserMenu: state.paywall.options.hideUserMenu,
        branding: state.branding,
    };
};

export default connect(
    mapStateToProps,
    {
        setForm,
        openModal,
        logoutUser,
    }
)(UserMenu);



// WEBPACK FOOTER //
// ./src/containers/UserMenu.js